// Services
import { ItemSelectionService } from 'NewAngular/services/item-selection.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/item-selection.service";
import * as i2 from "../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i3 from "@angular/common";
import * as i4 from "FoldersApp/features/folders-shared/folder-base/folder-base.component";
import * as i5 from "FoldersApp/features/folders-shared/set-view-root-folder/set-view-root-folder.directive";
import * as i6 from "../../../../../sharing/static/sharing/ts/pipes/get-owner-display-name.pipe";
const _c0 = a0 => ({ "text-22": a0 });
const _c1 = a0 => ({ visibility: a0 });
function FolderFolderableListItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "a", 5);
} if (rf & 2) {
    const folder_r2 = ctx.folder;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, !folder_r2.permissions.canEdit))("textContent", folder_r2.name)("disabled", !(folder_r2.permissions == null ? null : folder_r2.permissions.canView))("folderId", folder_r2.id);
} }
function FolderFolderableListItemComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "div", 7);
    i0.ɵɵpipe(2, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵelement(4, "div", 7);
    i0.ɵɵpipe(5, "getOwnerDisplayName");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 9)(7, "label", 10);
    i0.ɵɵelement(8, "input", 11)(9, "span", 12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const folder_r3 = ctx.folder;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, !folder_r3.permissions.canEdit))("textContent", i0.ɵɵpipeBind2(2, 5, folder_r3.modify_date, "longDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0, !folder_r3.permissions.canEdit))("textContent", i0.ɵɵpipeBind1(5, 8, folder_r3));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(14, _c1, ctx_r3.itemSelectionService.isSelected(folder_r3) ? "visible" : "hidden"));
} }
function FolderFolderableListItemComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-folderable-list-item", 13);
} if (rf & 2) {
    const folderable_r5 = ctx.folderable;
    const ancestorInfo_r6 = ctx.ancestorInfo;
    i0.ɵɵproperty("folderable", folderable_r5)("ancestorInfo", ancestorInfo_r6);
} }
function FolderFolderableListItemComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "span");
    i0.ɵɵtext(2, "There are no folders in this folder.");
    i0.ɵɵelementEnd()();
} }
export class FolderFolderableListItemComponent {
    constructor(itemSelectionService) {
        this.itemSelectionService = itemSelectionService;
    }
    selectFolderable(folderable) {
        // Users can only move items into a folder they have edit permission to.
        if (!folderable.item.permissions.canEdit)
            return;
        if (this.itemSelectionService.isSelected(folderable.item)) {
            this.itemSelectionService.deselectItem(folderable.item);
        }
        else {
            this.itemSelectionService.clearSelections();
            this.itemSelectionService.selectItem(folderable.item);
        }
    }
}
FolderFolderableListItemComponent.ɵfac = function FolderFolderableListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderFolderableListItemComponent)(i0.ɵɵdirectiveInject(i1.ItemSelectionService)); };
FolderFolderableListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderFolderableListItemComponent, selectors: [["ycn-folder-folderable-list-item"]], inputs: { folderable: "folderable", ancestorInfo: "ancestorInfo" }, standalone: false, decls: 9, vars: 6, consts: [["folderNameFragment", ""], ["folderColumnDataFragment", ""], ["listItemFragment", ""], ["emptyFolderFragment", ""], [3, "folderableClick", "folderable", "ancestorInfo", "folderColumnDataFragment", "listItemFragment", "emptyFolderFragment", "folderNameFragment"], ["draggable", "false", "href", "javascript:void(0)", "ycnDisabled", "", "ycn-set-view-root-folder", "", 3, "ngClass", "textContent", "disabled", "folderId"], [1, "td", "col-3"], [1, "file-td-wrap", 3, "ngClass", "textContent"], [1, "td", "col-3", "col-md-2"], [1, "file-td-control", "td"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "checkbox-single", "d-flex", 3, "ngStyle"], ["type", "checkbox", "checked", "true", "name", "securities-list", 1, "custom-control-input"], [1, "custom-control-indicator"], [3, "folderable", "ancestorInfo"], [1, "get-started-small", "flex-auto"]], template: function FolderFolderableListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-folder-base", 4);
        i0.ɵɵlistener("folderableClick", function FolderFolderableListItemComponent_Template_ycn_folder_base_folderableClick_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectFolderable($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, FolderFolderableListItemComponent_ng_template_1_Template, 1, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(3, FolderFolderableListItemComponent_ng_template_3_Template, 10, 16, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, FolderFolderableListItemComponent_ng_template_5_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(7, FolderFolderableListItemComponent_ng_template_7_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const folderNameFragment_r7 = i0.ɵɵreference(2);
        const folderColumnDataFragment_r8 = i0.ɵɵreference(4);
        const listItemFragment_r9 = i0.ɵɵreference(6);
        const emptyFolderFragment_r10 = i0.ɵɵreference(8);
        i0.ɵɵproperty("folderable", ctx.folderable)("ancestorInfo", ctx.ancestorInfo)("folderColumnDataFragment", folderColumnDataFragment_r8)("listItemFragment", listItemFragment_r9)("emptyFolderFragment", emptyFolderFragment_r10)("folderNameFragment", folderNameFragment_r7);
    } }, dependencies: [i2.DisabledDirective, i3.NgClass, i3.NgStyle, i4.FolderBaseComponent, FolderFolderableListItemComponent, i5.SetViewRootFolderDirective, i3.DatePipe, i6.GetOwnerDisplayName], encapsulation: 2 });
